<template>
  <el-card>
    <div class="store-micro-page">
      <div class="title mb20 flex item-center">门店页面</div>
      <ul class="custom-list flex flex-wrap">
        <li class="temp custom" @click="toTemp(null)">
          <div class="custom-wrapper flex item-center flex-center">
            <div class="text-center">
              <span class="hmicon icon-weiyemian"></span>
              <div>自定义模板</div>
            </div>
          </div>
          <div class="temp-title">&nbsp;</div>
        </li>
        <li class="list-item flex" v-for="(v, i) in list" :key="i">
          <div class="temp">
            <div class="temp-wrapper">
              <img :src="v.previewImg" alt="默认首页" />
              <div class="default-wrapper" v-if="v.enabledState === 'yes'">
                默认
              </div>
              <div class="temp-btn-wrapper">
                <div class="flex item-center wrapper">
                  <div class="flex flex-wrap flex-start">
                    <el-tooltip
                      class="item"
                      content="编辑"
                      placement="top"
                      style="color: #0081E5"
                    >
                      <el-button
                        @click="toTemp(v.micropageId)"
                        icon="hmicon icon-bianji"
                        circle
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      style="color: #E50065"
                    >
                      <el-button
                        @click="deleteItem(v.micropageId)"
                        icon="hmicon icon-shanchu"
                        circle
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="temp-title">
              {{ v.pageTitle }}
            </div>
          </div>
          <el-scrollbar
            wrap-class="store-list-wrapper"
            wrap-style="height: 423px;overflow-x: hidden;"
          >
            <div class="store-list">
              <div class="caption">
                {{ v.pageTitle }}
              </div>
              <dl class="store">
                <dt class="sub-title">
                  使用中（{{ v.useRelModelList.length }}）家门店
                </dt>
                <dd
                  class="flex store-item item-center"
                  v-for="(item, index) in v.useRelModelList"
                  :key="index"
                >
                  <div class="flex-1 flex item-center">
                    <div class="icon-wrapper">
                      <span class="hmicon icon-mendian"></span>
                    </div>
                    <div class="flex-1">
                      <span>{{ item.shopName }}</span>
                    </div>
                  </div>
                  <div>
                    <el-button
                      type="text"
                      size="small"
                      @click="switchStatus(item)"
                      >关闭</el-button
                    >
                  </div>
                </dd>
              </dl>
              <dl class="store">
                <dt class="sub-title">
                  未使用（{{ v.notUseRelModelList.length }}）家门店
                </dt>
                <dd
                  class="flex store-item item-center"
                  v-for="(item, index) in v.notUseRelModelList"
                  :key="index"
                >
                  <div class="flex-1 flex item-center">
                    <div class="icon-wrapper">
                      <span class="hmicon icon-mendian"></span>
                    </div>
                    <div class="flex-1">
                      <span>{{ item.shopName }}</span>
                    </div>
                  </div>
                  <div>
                    <el-button
                      class="blue"
                      type="text"
                      size="small"
                      @click="switchStatus(item)"
                      >使用</el-button
                    >
                  </div>
                </dd>
              </dl>
            </div>
          </el-scrollbar>
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import JDatePicker from "vue-jlunar-datepicker";
export default {
  components: { JDatePicker },
  data() {
    return {
      type: "DATERANGE",
      showBackYears: 2,
      width1: "300",
      clearable: true,
      list: [],
      micropageId: "",
      currentMicropageId: "",
      homeImg:
        "https://imgcdn.hemiao100.com/hemiaoBase/cdead4d7-3f67-43c5-85c1-5ee03c30f965.png",
      userCenterImg:
        "https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903104340.png",
      ruleForm: {
        hrefAddress: "",
        pageType: "index",
        enabledDate: [],
        enabledState: "close"
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        enabledDate: {
          required: false,
          message: "请选择时间",
          trigger: "change"
        }
      },
      dialogVisible: false
    };
  },
  computed: mapGetters(["indexTemp"]),
  watch: {
    indexTemp(val) {
      if (val.layoutDefaultBoList) {
        val.layoutDefaultBoList.map(v => {
          if (v.pageType === "home") {
            this.homeImg = v.previewImg;
          } else if (v.pageType === "center") {
            this.userCenterImg = v.previewImg;
          }
        });
      }
    }
  },
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      this.list = [];
      const { result } = await this.$store.dispatch(
        "queryStoreGoodShareTempList"
      );
      this.list = result;
    },
    async switchStatus(item) {
      let text = item.enabledState === "no" ? "使用" : "关闭";
      const result = await this.$confirm(`是否${text}此模板`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const copyItem = JSON.parse(JSON.stringify(item));
        copyItem.enabledState = copyItem.enabledState === "yes" ? "no" : "yes";
        const result = await this.$store.dispatch("shopUseTemp", copyItem);
        if (result.inMsg === "-1") {
          const res = await this.$confirm(result.errMsg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
          if (res === "confirm") {
            await this.$store.dispatch("shopChangeTempConfirm", copyItem);
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.queryList();
          }
          return;
        }
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
      }
    },
    deleteItem(micropageId) {
      this.$confirm(" 删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteTemp", {
            micropageId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                type: "success",
                message: "操作成功！"
              });
            }
            this.queryList();
          });
      });
    },
    toTemp(layoutId) {
      let query = {
        pageModel: "customize"
      };
      if (layoutId) {
        Object.assign(query, {
          layoutId,
          mode: "edit"
        });
      }
      this.$router.push({
        name: "StoreDecorationTemp",
        query
      });
    }
  }
};
</script>
<style lang="scss">
.store-micro-page {
  .el-scrollbar {
    box-shadow: 0px 0px 30px 0px rgba(226, 226, 226, 1);
    margin-bottom: 20px;
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
.title {
  position: relative;
  font-size: 14px;
  font-weight: bold;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: rgba(229, 0, 101, 1);
    border-radius: 2px 0px 2px 0px;
    margin-right: 5px;
  }
}

.list-item {
  margin-left: 20px;
  .store-list {
    width: 226px;
    overflow-x: hidden;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 0px 30px 0px rgba(226, 226, 226, 1);
    font-size: 14px;
    .store-item {
      margin-bottom: 20px;
    }

    .icon-wrapper {
      background: #efefef;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      line-height: 28px;
      text-align: center;
      margin-right: 8px;
    }
    .caption {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 30px;
    }
    .sub-title {
      color: #999;
      margin-bottom: 20px;
    }
    .store {
      margin-bottom: 30px;
    }
  }
}

.store-list-wrapper {
  box-shadow: 0px 0px 30px 0px rgba(226, 226, 226, 1);
}

.temp {
  position: relative;
  cursor: pointer;
  margin-bottom: 20px;
  overflow: hidden;
  &:hover {
    .temp-btn-wrapper {
      display: block;
    }
  }
  .default-wrapper {
    background: #e50065;
    color: #fff;
    position: absolute;
    top: -50px;
    left: -50px;
    font-size: 14px;
    width: 100px;
    height: 100px;
    line-height: 160px;
    text-align: center;
    transform: rotate(315deg);
  }
  &-wrapper {
    height: 394px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    width: 226px;
    text-align: center;
    padding: 11px 0;
  }
  &-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 38px;
    height: 394px;
    padding-left: 35px;
    display: none;
    background: rgba(0, 0, 0, 0.8);
    .wrapper {
      height: 100%;
    }
    .el-button {
      margin: 0;
      margin-bottom: 20px;
      margin-right: 15px;
    }
  }
}
.temp {
  width: 226px;
  height: 423px;
  box-shadow: 0px 0px 30px 0px rgba(226, 226, 226, 1);
}

.temp.custom {
  .custom-wrapper {
    height: 394px;
    background: #ffd4e7;
    text-align: center;
    color: #e50065;
    font-size: 14px;
    .hmicon {
      font-size: 42px;
    }
  }
}
</style>
